function detail(_target, _propertyKey, descriptor) {
  const next = descriptor.value;

  Object.assign(descriptor, {
    value(event) {
      return event instanceof CustomEvent
        ? Reflect.apply(next, this, [event.detail])
        : Reflect.apply(next, this, arguments);
    },
  });
}

export default detail;
